const translateAwsError = error => {
    const translations = {
        'UserNotFoundException': 'Incorrect username or password.'
    };

    return translations[error];
}

export default translateAwsError;